/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecipientDto as FeatureMailingListsRecipientDto } from '../../models/feature/mailing-lists/recipient-dto';
import { RecipientListBuilderDto as FeatureMailingListsRecipientListBuilderDto } from '../../models/feature/mailing-lists/recipient-list-builder-dto';

export interface BuildRecipientList$Params {
      body: FeatureMailingListsRecipientListBuilderDto
}

export function buildRecipientList(http: HttpClient, rootUrl: string, params: BuildRecipientList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureMailingListsRecipientDto>>> {
  const rb = new RequestBuilder(rootUrl, buildRecipientList.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FeatureMailingListsRecipientDto>>;
    })
  );
}

buildRecipientList.PATH = '/edit-mailing-list-page/build-recipient-list';

